/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default class PageSection extends Component {
    render() {
        return (
            <div className={`rec-section-outer-wrap ${this.props.className}`}>
                {this.props.children}
            </div>
        );
    }
}

PageSection.propTypes = propTypes;
